




























import PointsComponent from "./PointsComponent";
export default PointsComponent;
